import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const submitContactInformationStarted = () => {
  return {
    type: actionTypes.SUBMIT_CONTACT_INFORMATION_STARTED,
  };
};
export const submitContactInformationSuccess = () => {
  return {
    type: actionTypes.SUBMIT_CONTACT_INFORMATION_SUCCESS,
  };
};
export const submitContactInformationFailed = (errorMessage) => {
  return {
    type: actionTypes.SUBMIT_CONTACT_INFORMATION_FAILED,
    errorMessage: errorMessage,
  };
};

export const resetSubmitContactInformation = () => {
  return {
    type: actionTypes.RESET_SUBMIT_CONTACT_INFORMATION,
  };
};

export const submitContactInformation = (contactInfo: {
  claimId: number;
  patientId: number;
  phoneNumber: string;
  email: string;
}) => {
  return (dispatch) => {
    dispatch(submitContactInformationStarted());
    axios
      .post(serverconfigs.submitContactInformationUrl+`/`, contactInfo)
      .then((response) => {
        console.log(response.data);
        dispatch(submitContactInformationSuccess());
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            dispatch(
              submitContactInformationFailed(error.response.data.message)
            );
          } else {
            dispatch(submitContactInformationFailed(error.message));
          }
          logFirebaseEvent("Exception400");
        }                 
        else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
          dispatch(submitContactInformationFailed(error.message));
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
          dispatch(submitContactInformationFailed(error.message));
        }else dispatch(submitContactInformationFailed(error.message));
      });
  };
};
